import { NgModule } from '@angular/core';

import { ClaimsDirective } from './claims.directive';
import { SiteConfigDirective } from './config.directive';

@NgModule({
    declarations: [
        ClaimsDirective,
        SiteConfigDirective,
    ],
    imports: [
    ],
    providers: [],
    exports: [
        ClaimsDirective,
        SiteConfigDirective,
    ]
})
export class DirectivesModule { }


// WEBPACK FOOTER //
// ./src/app/shared/directives/directives.module.ts